module.exports = __webpack_public_path__ + "static/media/dnt.8f869cfe.svg";